import { HOST_NAME } from "../constants";
import { getAccessToken } from "../jwt";
import store from "../store";
import {
  DATASET_PROCESS_SUCCESS,
  DATASET_DELETE_SUCCESS,
  DATASET_PROCESS_FAILURE,
  DATASET_DELETE_FAILURE,
} from "../actions/types";
import {
  datasetProcessSuccess,
  datasetProcessFailure,
  datasetDeleteSuccess,
  datasetDeleteFailure,
} from "../actions/datasetActions";

export const initWS = () => {
  const url = new URL(`wss://${HOST_NAME}/recorder/api/ws`);
  url.search = new URLSearchParams({ token: getAccessToken() });
  const ws = new WebSocket(url);
  let message;
  ws.onmessage = (msgEvent) => {
    try {
      message = JSON.parse(msgEvent.data);
    } catch (error) {
      console.log("ERROR_PARSING_WS_MESSAGE", msgEvent.data);
    }
    switch (message.type) {
      case DATASET_PROCESS_SUCCESS:
        store.dispatch(
          datasetProcessSuccess(message.project, message.recordings)
        );
        break;
      case DATASET_PROCESS_FAILURE:
        store.dispatch(datasetProcessFailure(message.project));
        break;
      case DATASET_DELETE_SUCCESS:
        store.dispatch(datasetDeleteSuccess(message.project_id));
        break;
      case DATASET_DELETE_FAILURE:
        store.dispatch(datasetDeleteFailure(message.project_id, message.error));
        break;
      default:
        console.log("UNKNOWN_MESSAGE_TYPE", message);
        break;
    }
  };
};
